
import { Component, Prop, Vue } from 'vue-property-decorator';
import { debounce } from 'vue-debounce';
import MandatoryColorModuleFilters from '@/components/global/color-module/MandatoryColorModuleFilters.vue';

@Component({
    name: 'ColorModuleSearch',
    components: {
        MandatoryColorModuleFilters,
    },
})
export default class ColorModuleSearch extends Vue {
    @Prop({ required: true }) private filtersActive!: boolean;
    @Prop({ required: true }) private requestFiltersActive!: boolean;
    @Prop({ required: true }) private activeTab!: string;
    @Prop({ required: true }) private filters!: any;
    @Prop({ required: true }) private searchQuery!: string;
    @Prop({ required: false, default: false }) private showLatestColors!: boolean;

    private isCacheResetIconLoading = false;

    private get filterActiveState(): boolean {
        return this.activeTab === 'color-request' ? this.requestFiltersActive : this.filtersActive;
    }

    private debouncedColorSearch = debounce((event: any) => {
        this.onSearch(event.target.value, false);
    }, 50);

    private clearFilters() {
        this.$emit('clearFilters');
        this.activateSpinningAnimation();
    }

    private activateSpinningAnimation() {
        this.isCacheResetIconLoading = true;
        setTimeout(() => {
            this.isCacheResetIconLoading = false;
        }, 500);
    }

    private onSearch(query: string, shouldFetch: boolean = false) {
        this.$emit('search', { query, shouldFetch });
    }

    private onFilterActiveStateChange(val: boolean) {
        this.$emit('setFilters', val);
    }

    private onLatestColorsToggle(val: boolean) {
        this.$emit('toggleLatestColors', val);
    }
}
